import React from 'react';
import { SectionSkeleton, SECTION_SKELETON_VARIANTS } from './SectionSkeleton';

/**
 * ChartSkeleton — backward-compatible wrapper.
 *
 * @deprecated Use `<SectionSkeleton variant="chart" />` instead.
 * @param {boolean} isMobile - viewport flag [Optional]
 * @param {string} title - section title [Optional]
 */
export const ChartSkeleton = ({ isMobile, title }) => (
  <SectionSkeleton
    variant={SECTION_SKELETON_VARIANTS.chart}
    isMobile={isMobile}
    title={title}
  />
);
